<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '其他车辆费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="car" slot-scope="prop">
          <ChooseCar :isRadio="true" v-model="prop.form.car" @change="handleCarChange" />
        </section>
        <section slot="order" slot-scope="prop">
          <ChooseOrder
            ref="order"
            :otherSearchData="{
              plateNumber: prop.form.car.plateNumber,
              orgId,
            }"
            :isRadio="true"
            :customSearchboxData="customSearchboxData"
            :handleParamsData="handleParamsData"
            v-model="prop.form.order"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import ChooseCar from 'components/choose/car';
import ChooseOrder from 'components/choose/order';
export default {
  components: {
    ChooseCar,
    ChooseOrder,
  },
  props: {
    orgId: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '车牌号码',
            value: 'car',
            slot: true,
            default: {},
          },
          {
            label: '牌照类型',
            value: 'licenceTypeName',
            type: 'input',
            placeholder: '请输入牌照类型',
            readyonly: true,
          },
          {
            label: '费用日期',
            value: 'feeAscriptionDate',
            type: 'date',
            default: '',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '费用金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '费用金额',
            unit: '元',
          },
          {
            label: '费用说明',
            value: 'payRemark',
            type: 'input',
            placeholder: '请输入费用说明',
          },
        ],
        rules: { // 表单验证规则
          car: [
            { required: true, message: '请选择车牌号码', trigger: 'blur' },
          ],
          payAmt: [
            { required: true, message: '费用金额', trigger: 'blur' },
          ],
          feeAscriptionDate: [
            { required: true, message: '请输入费用日期', trigger: 'blur' },
          ],
        },
      },
      customSearchboxData: {
        form: [
          { // 司机姓名
            label: '司机姓名',
            value: 'carDriverMan',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 手机号码
            label: '手机号码',
            value: 'carDriverPhone',
            type: 'input',
            placeholder: '请输入手机号码',
          },
          { // 订单号
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 发车时间
            label: '发车时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择发车时间',
            attr: {
              type: 'datetimerange',
            },
            width: '532px',
          },
        ],
      },
    };
  },
  methods: {
    handleCarChange (data) { // 车辆选择时
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: false,
        names: ['order'],
      });
      const car = this.$refs.customForm.getVal('car');
      this.$refs.customForm.setVal('licenceTypeName', car.licenceTypeName);
    },

    async setDefaultTime () {
      const date = new Date();
      const y = date.getFullYear();
      const m = date.getMonth() + 1;

      const startDependTime = `${m === 1 ? Number(y) - 1 : y}-${m === 1 ? m : m - 1}-1 00:00:00`;
      const endDependTime = this.formatDate(new Date(), 1);

      this.setFormAttrVal({
        form: this.customSearchboxData,
        attr: 'default',
        value: [startDependTime, endDependTime],
        names: ['Time'],
      });
    },

    handleParamsData (searchBoxData) {
      if (searchBoxData) {
        searchBoxData.filtrationExpense = -1;
        if (searchBoxData.Time && searchBoxData.Time.length) {
          searchBoxData.startDependTime = this.formatDate(searchBoxData.Time[0], 1);
          searchBoxData.endDependTime = this.formatDate(searchBoxData.Time[1], 1);
        }
        delete searchBoxData.Time;
      }
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(async () => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        await this.setDefaultTime();
        if (item) { // 修改
          this.type = 'edit';
          item.order = {
            orderId: item.orderId,
            plateNumber: item.plateNumber,
          };
          item.car = {
            plateNumber: item.plateNumber,
            licenceType: item.licenceType,
            licenceTypeName: item.licenceTypeName,
          };
          this.$refs.customForm.setVal(item);
          this.handleCarChange(false);
        } else { // 新增
          this.type = 'add';
          this.setFormAttrVal({
            form: this.formData,
            attr: 'hide',
            value: true,
            names: ['order'],
          });
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 车辆信息
      form.plateNumber = form.car.plateNumber;
      form.licenceType = form.car.licenceType;
      form.licenceTypeName = form.car.licenceTypeName;
      form.feeAscriptionDate = this.formatDate(form.feeAscriptionDate);
      delete form.order;
      delete form.car;
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
